import _Promise from 'babel-runtime/core-js/promise';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import { getProjectInfoById } from 'jcb-token-kit';

var useCache = function useCache() {
  var updateProjectNames = function updateProjectNames(projectId, name) {
    var storageNames = JSON.parse(sessionStorage.getItem('projectNames') || '{}');
    storageNames[projectId] = name;
    sessionStorage.setItem('projectNames', _JSON$stringify(storageNames));
  };

  var getProjectNames = function getProjectNames(projectId) {
    var storageNames = JSON.parse(sessionStorage.getItem('projectNames') || '{}');
    if (storageNames[projectId]) {
      return storageNames[projectId];
    }
    return null;
  };

  var updateProjectName = function updateProjectName(projectId, name) {
    if (!name) {
      return getProjectInfoById(projectId).then(function (res) {
        updateProjectNames(projectId, res.title);
        sessionStorage.setItem('projectName', res.title);
        return res.title;
      });
    } else {
      sessionStorage.setItem('projectName', name);
      updateProjectNames(projectId, name);
      return name;
    }
  };

  // Promise
  var getProjectName = function getProjectName(projectId) {
    var projectName = getProjectNames(projectId) || '';
    if (projectName) {
      updateProjectName(projectId);
      return _Promise.resolve(projectName);
    } else {
      return updateProjectName(projectId);
    }
  };

  var projectName = function projectName(projectId) {
    var projectName = getProjectNames(projectId) || sessionStorage.getItem('projectName') || '';
    return projectName;
  };

  return { getProjectName: getProjectName, updateProjectName: updateProjectName, projectName: projectName };
};

var _default = useCache;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useCache, 'useCache', 'src/components/useCache.js');
  reactHotLoader.register(_default, 'default', 'src/components/useCache.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();